import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, createItem, updateItem, deleteById } from "./emailTemplateAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchAll = createAsyncThunk(
  "emailTemplate/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const addItem = createAsyncThunk(
  "emailTemplate/addItem",
  async (payload) => {
    const response = await createItem(payload);
    return response.data;
  }
);

export const editItem = createAsyncThunk(
  "emailTemplate/editItem",
  async ({ params, id }) => {
    const response = await updateItem(params, id);
    return response.data;
  }
);

export const removeById = createAsyncThunk(
  "emailTemplate/removeById",
  async (id) => {
    const response = await deleteById(id);
    return response.data;
  }
);

export const emailTemplateSlice = createSlice({
  name: "emailTemplate",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = emailTemplateSlice.actions;

export const selectData = (state) => state.emailTemplate.data;
export const selectLoading = (state) => state.emailTemplate.loading;
export const selectError = (state) => state.emailTemplate.error;
export const selectPageNo = (state) => state.emailTemplate.pageNo;
export const selectPageSize = (state) => state.emailTemplate.pageSize;
export const selectTotalRecord = (state) => state.emailTemplate.totalRecord;
export const selectSelected = (state) => state.emailTemplate.selected;
export const selectResult = (state) => state.emailTemplate.result;

export default emailTemplateSlice.reducer;
